import { useState } from 'react';

import classes from './ButtonGroup.module.scss';

export const ButtonGroup = ({
	defaultActive,
	items,
	clsx,
}: {
	defaultActive?: string;
	clsx?: {
		button?: string;
		root?: string;
	};
	items: {
		label: string;
		id: string | number;
		onClick?: (value: string | number) => void;
	}[];
}) => {
	const [active, setActive] = useState<string | number>(defaultActive || '');
	const { button: clsxButton = '', root: clsxRoot = '' } = clsx || {};
	return (
		<div className={`${classes.btnGroup} ${classes.btnGroupPadding} ${clsxRoot}`}>
			{items.map((item) => (
				<button
					key={item.id}
					className={`${classes.btnGroupItem} ${
						active === item.id ? classes.active : ''
					} ${clsxButton}`}
					onClick={() => {
						setActive(item.id);
						if (item.onClick) item.onClick(item.id);
					}}
					type='button'
				>
					{item.label}
				</button>
			))}
		</div>
	);
};
